import styled from "styled-components";

export const RoleListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const SelectCardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const SelectCardContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  gap: 16px;
`;

export const SelectCardLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 300px;
`;

export const SelectCardRightColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  width: calc(100% - 300px);
`;

export const IconWithNumberContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ViewDetailsButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 4px;
  color: ${(props) => props.theme.colors.primary || "#1976d2"};
  font-size: ${(props) => props.theme.typography?.body?.regular?.size || "14px"};
  font-family: ${(props) => props.theme.typography?.body?.regular?.family || props.theme.fonts?.family?.inter || "Inter"};
  font-weight: ${(props) => props.theme.typography?.body?.regular?.weight || 400};
  
  &:hover {
    opacity: 0.8;
  }
`;

